// small utility to handle loading data that may or may not be required
// when required() turns true, sends AJAX request to url, loading the result (via jsonMapping) into the target
// provides loading, loaded and error observables to report state of loader
// returns the computed that watches required -- be sure to dispose as needed.
import S from 's-js';
import { Loader as _Loader } from './loader';
import { IAjax } from 'lib/Ajax';

export type Loader = _Loader;

export function maybeLoader<T>(ajax : IAjax, url : string, target : (v : T) => void, required : () => boolean) {
    var loader = _Loader(ajax, url, target),
        watcher = S(function () {
            if (required()) loader.Load();
        });
    
    return loader;
}


// WEBPACK FOOTER //
// ./lib/maybeLoader.ts